import React from 'react';

const WingsComponent = () => {
  const wings="https://jamaappprod.s3.ap-south-1.amazonaws.com/Website/maxwealthweb/Web-Images+compressed/Roots+and+Wings%2C+3lens+and+LSG/Wings.png";
  return (
    <div className="bg-white">
      <div className="max-w-6xl w-full mx-auto px-4 sm:px-6 lg:px-8 py-4 md:py-6 lg:py-8">
        <div className="flex flex-col md:flex-row-reverse items-center gap-8">
          {/* Image side (right side in desktop) */}
          <div className="w-full md:w-2/5">
            <img 
              src={wings} 
              alt="Soaring wings" 
              className="rounded-lg w-full h-auto object-cover"
            />
          </div>
          
          {/* Content side (left side in desktop) */}
          <div className="w-full md:w-3/5">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-[#113262] mb-4">Wings</h2>
            <h3 className="text-lg font-medium text-gray-800 mb-4">Scalable Growth. Real Cash Flows. Market Resilience.</h3>
            
            <p className="text-gray-700 mb-4">
              Just as birds with strong wings can fly higher and farther, we back companies 
              with a long runway for growth. These are businesses that:
            </p>
            
            <ul className="mb-4 space-y-2">
              {[
                'Consistently grow revenues and profits above GDP growth (1.5x to 3x)',
                'Generate high operating cash flows',
                'Show pricing power in their industry',
                'Recover faster during downturns and maintain momentum'
              ].map((item, index) => (
                <li key={index} className="flex items-start">
                  <svg className="h-5 w-5 text-gray-600 mt-0.5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <span className="ml-2 text-gray-700">{item}</span>
                </li>
              ))}
            </ul>
            
            <p className="text-gray-700">
              We look beyond top-line growth. We focus on resilience—companies that not only rise, 
              but bounce back stronger. Real growth, backed by real numbers.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WingsComponent;